import React from 'react';

/**
 * Calls `onExited` once, when the component using it unmounts after the
 * category filter closed. `CategoryFilterPopoverExit` renders it inside the
 * popover, so the unmount is the popover's own, after its exit animation. An
 * unmount while the filter is still open (StrictMode's development-only
 * remount) is ignored.
 */
export const useCategoryFilterPopoverExit = (
    isOpen: boolean,
    onExited?: () => void,
): void => {
    const latest = React.useRef({ isOpen, onExited });
    latest.current = { isOpen, onExited };

    React.useEffect(
        () => () => {
            if (!latest.current.isOpen) {
                latest.current.onExited?.();
            }
        },
        [],
    );
};
